import { Property } from '../models';

export const MOCK_PROPERTIES: Property[] = [
  {
    id: 1,
    name: 'Nadmorska Willa z Widokiem',
    type: 'dom',
    location: 'Ustka',
    rating: 4.9,
    reviews: 127,
    distanceToBeach: 150,
    mainImage: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1200&q=85',
    amenities: ['wifi', 'parking', 'grill', 'garden', 'terrace', 'fireplace'],
    petsAllowed: true,
    instantBooking: true,
    superHost: true,
    description: 'Kompleks willowy z bezpośrednim widokiem na morze. Idealne miejsce dla rodzin i grup szukających spokoju i luksusu nad Bałtykiem.',
    host: { name: 'Marianna', since: 2019, avatar: 'https://i.pravatar.cc/100?img=1' },
    checkIn: '15:00',
    checkOut: '11:00',
    units: [
      {
        id: 'u1',
        name: 'Domek Mały',
        subtitle: 'Przytulny domek dla pary lub małej rodziny',
        guests: 4,
        bedrooms: 2,
        bathrooms: 1,
        size: 45,
        price: 350,
        images: [
          'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1200&q=85',
          'https://images.unsplash.com/photo-1616137466211-f939a420be84?w=1200&q=85',
          'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1200&q=85'
        ],
        amenities: ['wifi', 'parking', 'terrace'],
        description: 'Kameralny domek z tarasem i widokiem na ogród. Idealny dla par lub rodziny z dzieckiem.'
      },
      {
        id: 'u2',
        name: 'Domek Duży',
        subtitle: 'Przestronny dom dla całej rodziny',
        guests: 8,
        bedrooms: 4,
        bathrooms: 2,
        size: 95,
        price: 550,
        images: [
          'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&q=85',
          'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&q=85',
          'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1200&q=85',
          'https://images.unsplash.com/photo-1616137466211-f939a420be84?w=1200&q=85'
        ],
        amenities: ['wifi', 'parking', 'grill', 'garden', 'terrace', 'fireplace'],
        description: 'Duży dom z 4 sypialniami, 2 łazienkami, salonem z kominkiem i prywatnym ogrodem z grillem.'
      },
      {
        id: 'u3',
        name: 'Apartament Studio',
        subtitle: 'Nowoczesne studio dla 2 osób',
        guests: 2,
        bedrooms: 1,
        bathrooms: 1,
        size: 30,
        price: 220,
        images: [
          'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=1200&q=85',
          'https://images.unsplash.com/photo-1630699144867-37acec97df5a?w=1200&q=85'
        ],
        amenities: ['wifi', 'balcony', 'tv'],
        description: 'Przytulne studio z balkonem. Idealne na romantyczny wypad we dwoje.'
      }
    ]
  },
  {
    id: 2,
    name: 'Apartamenty Bałtycka Fala',
    type: 'apartament',
    location: 'Łeba',
    rating: 4.7,
    reviews: 89,
    distanceToBeach: 50,
    mainImage: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=1200&q=85',
    amenities: ['wifi', 'parking', 'air_conditioning', 'balcony', 'tv'],
    petsAllowed: false,
    instantBooking: true,
    superHost: false,
    description: 'Nowoczesny kompleks apartamentów zaledwie 50 metrów od plaży w sercu Łeby.',
    host: { name: 'Tomasz', since: 2021, avatar: 'https://i.pravatar.cc/100?img=3' },
    checkIn: '14:00',
    checkOut: '10:00',
    units: [
      {
        id: 'u1',
        name: 'Apartament Standard',
        subtitle: 'Komfortowy apartament z balkonem',
        guests: 4,
        bedrooms: 2,
        bathrooms: 1,
        size: 48,
        price: 280,
        images: [
          'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=1200&q=85',
          'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1200&q=85',
          'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=1200&q=85'
        ],
        amenities: ['wifi', 'balcony', 'tv', 'air_conditioning'],
        description: 'Apartament z 2 sypialniami, balkonem z widokiem na morze i w pełni wyposażoną kuchnią.'
      },
      {
        id: 'u2',
        name: 'Apartament Premium',
        subtitle: 'Luksusowy apartament z tarasem',
        guests: 6,
        bedrooms: 3,
        bathrooms: 2,
        size: 75,
        price: 420,
        images: [
          'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1200&q=85',
          'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=1200&q=85',
          'https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=1200&q=85'
        ],
        amenities: ['wifi', 'parking', 'air_conditioning', 'balcony', 'tv', 'dishwasher'],
        description: 'Przestronny apartament premium z dużym tarasem, 3 sypialniami i luksusowym wykończeniem.'
      }
    ]
  },
  {
    id: 3,
    name: 'Leśne Chaty Jastrzębia',
    type: 'chata',
    location: 'Jastrzębia Góra',
    rating: 4.95,
    reviews: 203,
    distanceToBeach: 800,
    mainImage: 'https://images.unsplash.com/photo-1587061949409-02df41d5e562?w=1200&q=85',
    amenities: ['wifi', 'parking', 'grill', 'fireplace', 'sauna', 'jacuzzi'],
    petsAllowed: true,
    instantBooking: false,
    superHost: true,
    description: 'Urokliwe drewniane chaty otoczone lasem. Sauna, jacuzzi i grill do dyspozycji gości.',
    host: { name: 'Kasia', since: 2018, avatar: 'https://i.pravatar.cc/100?img=5' },
    checkIn: '16:00',
    checkOut: '10:00',
    units: [
      {
        id: 'u1',
        name: 'Chata Romantyczna',
        subtitle: 'Klimatyczna chata dla pary',
        guests: 2,
        bedrooms: 1,
        bathrooms: 1,
        size: 35,
        price: 280,
        images: [
          'https://images.unsplash.com/photo-1587061949409-02df41d5e562?w=1200&q=85',
          'https://images.unsplash.com/photo-1510798831971-661eb04b3739?w=1200&q=85'
        ],
        amenities: ['wifi', 'fireplace', 'jacuzzi'],
        description: 'Intymna chata z kominkiem i prywatnym jacuzzi. Idealna na romantyczny weekend.'
      },
      {
        id: 'u2',
        name: 'Chata Rodzinna',
        subtitle: 'Przestronna chata dla rodziny',
        guests: 6,
        bedrooms: 3,
        bathrooms: 1,
        size: 70,
        price: 420,
        images: [
          'https://images.unsplash.com/photo-1510798831971-661eb04b3739?w=1200&q=85',
          'https://images.unsplash.com/photo-1604014237800-1c9102c219da?w=1200&q=85',
          'https://images.unsplash.com/photo-1595521624992-48a59aef95e3?w=1200&q=85'
        ],
        amenities: ['wifi', 'parking', 'grill', 'fireplace', 'sauna'],
        description: 'Duża chata z 3 sypialniami, sauną i prywatnym terenem z grillem.'
      }
    ]
  },
  {
    id: 4,
    name: 'Sopot Prestige Residence',
    type: 'apartament',
    location: 'Sopot',
    rating: 4.85,
    reviews: 156,
    distanceToBeach: 200,
    mainImage: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&q=85',
    amenities: ['wifi', 'air_conditioning', 'balcony', 'tv', 'coffee_machine'],
    petsAllowed: false,
    instantBooking: true,
    superHost: true,
    description: 'Ekskluzywne apartamenty w sercu Sopotu. Luksus i komfort w najlepszej lokalizacji.',
    host: { name: 'Michał', since: 2020, avatar: 'https://i.pravatar.cc/100?img=8' },
    checkIn: '15:00',
    checkOut: '11:00',
    units: [
      {
        id: 'u1',
        name: 'Studio Deluxe',
        subtitle: 'Eleganckie studio z widokiem',
        guests: 2,
        bedrooms: 1,
        bathrooms: 1,
        size: 38,
        price: 380,
        images: [
          'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&q=85',
          'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=1200&q=85'
        ],
        amenities: ['wifi', 'air_conditioning', 'balcony', 'tv', 'coffee_machine'],
        description: 'Designerskie studio z panoramicznym widokiem na morze i molo.'
      },
      {
        id: 'u2',
        name: 'Apartament Executive',
        subtitle: 'Luksusowy apartament 2-pokojowy',
        guests: 4,
        bedrooms: 2,
        bathrooms: 1,
        size: 65,
        price: 580,
        images: [
          'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=1200&q=85',
          'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=1200&q=85',
          'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=1200&q=85'
        ],
        amenities: ['wifi', 'air_conditioning', 'balcony', 'tv', 'coffee_machine', 'dishwasher'],
        description: 'Przestronny apartament z 2 sypialniami, w pełni wyposażoną kuchnią i balkonem.'
      },
      {
        id: 'u3',
        name: 'Penthouse Suite',
        subtitle: 'Ekskluzywny penthouse na ostatnim piętrze',
        guests: 6,
        bedrooms: 3,
        bathrooms: 2,
        size: 110,
        price: 950,
        images: [
          'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=1200&q=85',
          'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=1200&q=85',
          'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&q=85'
        ],
        amenities: ['wifi', 'air_conditioning', 'terrace', 'tv', 'coffee_machine', 'dishwasher', 'jacuzzi'],
        description: 'Luksusowy penthouse z prywatnym tarasem, jacuzzi i panoramicznym widokiem na Zatokę Gdańską.'
      }
    ]
  },
  {
    id: 5,
    name: 'Rodzinne Domki Władysławowo',
    type: 'dom',
    location: 'Władysławowo',
    rating: 4.6,
    reviews: 78,
    distanceToBeach: 400,
    mainImage: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=1200&q=85',
    amenities: ['wifi', 'parking', 'grill', 'garden', 'playground', 'bikes'],
    petsAllowed: true,
    instantBooking: true,
    superHost: false,
    description: 'Kompleks rodzinnych domków z ogrodem i placem zabaw. Rowery w cenie pobytu.',
    host: { name: 'Anna', since: 2022, avatar: 'https://i.pravatar.cc/100?img=9' },
    checkIn: '14:00',
    checkOut: '10:00',
    units: [
      {
        id: 'u1',
        name: 'Domek 4-osobowy',
        subtitle: 'Kompaktowy domek dla małej rodziny',
        guests: 4,
        bedrooms: 2,
        bathrooms: 1,
        size: 50,
        price: 320,
        images: [
          'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=1200&q=85',
          'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=1200&q=85'
        ],
        amenities: ['wifi', 'parking', 'garden', 'bikes'],
        description: 'Przytulny domek z 2 sypialniami i prywatnym ogródkiem.'
      },
      {
        id: 'u2',
        name: 'Domek 8-osobowy',
        subtitle: 'Duży dom dla rodziny lub grupy',
        guests: 8,
        bedrooms: 4,
        bathrooms: 2,
        size: 95,
        price: 520,
        images: [
          'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=1200&q=85',
          'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=1200&q=85',
          'https://images.unsplash.com/photo-1600573472550-8090b5e0745e?w=1200&q=85'
        ],
        amenities: ['wifi', 'parking', 'grill', 'garden', 'playground', 'bikes'],
        description: 'Przestronny dom z 4 sypialniami, dużym ogrodem z grillem i placem zabaw.'
      },
      {
        id: 'u3',
        name: 'Domek 10-osobowy XL',
        subtitle: 'Największy dom dla dużej grupy',
        guests: 10,
        bedrooms: 5,
        bathrooms: 3,
        size: 130,
        price: 680,
        images: [
          'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=1200&q=85',
          'https://images.unsplash.com/photo-1600573472550-8090b5e0745e?w=1200&q=85',
          'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=1200&q=85'
        ],
        amenities: ['wifi', 'parking', 'grill', 'garden', 'playground', 'bikes', 'fireplace'],
        description: 'Największy dom w kompleksie - 5 sypialni, 3 łazienki, salon z kominkiem i ogromny ogród.'
      }
    ]
  },
  {
    id: 6,
    name: 'Klif Apartments',
    type: 'apartament',
    location: 'Międzyzdroje',
    rating: 4.75,
    reviews: 64,
    distanceToBeach: 300,
    mainImage: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=1200&q=85',
    amenities: ['wifi', 'tv', 'kitchenette', 'balcony'],
    petsAllowed: false,
    instantBooking: true,
    superHost: false,
    description: 'Apartamenty z widokiem na klif i morze. Blisko Wolińskiego Parku Narodowego.',
    host: { name: 'Piotr', since: 2021, avatar: 'https://i.pravatar.cc/100?img=12' },
    checkIn: '14:00',
    checkOut: '10:00',
    units: [
      {
        id: 'u1',
        name: 'Kawalerka z widokiem',
        subtitle: 'Przytulna kawalerka dla 2 osób',
        guests: 2,
        bedrooms: 1,
        bathrooms: 1,
        size: 28,
        price: 180,
        images: [
          'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=1200&q=85',
          'https://images.unsplash.com/photo-1630699144867-37acec97df5a?w=1200&q=85'
        ],
        amenities: ['wifi', 'tv', 'kitchenette', 'balcony'],
        description: 'Kompaktowa kawalerka z aneksem kuchennym i balkonem z widokiem na klif.'
      },
      {
        id: 'u2',
        name: 'Apartament 2-pokojowy',
        subtitle: 'Wygodny apartament dla rodziny',
        guests: 4,
        bedrooms: 2,
        bathrooms: 1,
        size: 50,
        price: 290,
        images: [
          'https://images.unsplash.com/photo-1630699144867-37acec97df5a?w=1200&q=85',
          'https://images.unsplash.com/photo-1560185007-c5ca9d2c014d?w=1200&q=85',
          'https://images.unsplash.com/photo-1615874959474-d609969a20ed?w=1200&q=85'
        ],
        amenities: ['wifi', 'tv', 'kitchenette', 'balcony', 'parking'],
        description: 'Przestronny apartament z 2 sypialniami, balkonem i miejscem parkingowym.'
      }
    ]
  }
];

export interface MarkerPosition {
  propertyId: number;
  top: string;
  left: string;
}

export const MARKER_POSITIONS: MarkerPosition[] = [
  { propertyId: 1, top: '48%', left: '18%' },
  { propertyId: 2, top: '42%', left: '42%' },
  { propertyId: 3, top: '38%', left: '68%' },
  { propertyId: 4, top: '32%', left: '82%' },
  { propertyId: 5, top: '52%', left: '75%' },
  { propertyId: 6, top: '55%', left: '8%' }
];
